import { Component, ChangeDetectorRef, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  template: `
    <div class="min-h-screen bg-linear-to-br from-blue-500 to-purple-600 flex items-center justify-center px-4">
      <div class="bg-white rounded-lg shadow-xl p-8 w-full max-w-md">
        <h2 class="text-2xl font-bold text-gray-900 mb-6 text-center">Recover Password</h2>
        <p class="text-gray-600 mb-6 text-center">
          Enter your email address and we'll send you a link to reset your password.
        </p>

        <form (ngSubmit)="onSubmit()" class="space-y-4">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
            <input
              type="email"
              id="email"
              [(ngModel)]="email"
              name="email"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
              placeholder="Enter your email"
              required
            />
          </div>

          <button
            type="submit"
            [disabled]="loading"
            class="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            @if (loading) {
              Sending...
            } @else {
              Send Recovery Email
            }
          </button>
        </form>

        <p class="mt-6 text-center">
          <a [routerLink]="['/login']" class="text-blue-500 hover:text-blue-700 font-semibold cursor-pointer">
            Back to Login
          </a>
        </p>
      </div>
    </div>
  `,
})
export class ForgotPasswordComponent {
  email = '';
  loading = false;

  constructor(
    private authService: AuthService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) { }

  onSubmit(): void {
    if (!this.email) {
      this.toastService.error('Please enter your email');
      return;
    }

    this.loading = true;
    this.cdr.detectChanges();

    this.authService.forgotPassword(this.email).subscribe({
      next: (res) => {
        this.ngZone.run(() => {
          this.toastService.success(res.message);
          this.loading = false;
          this.email = '';
          this.cdr.detectChanges();
        });
      },
      error: (err) => {
        this.ngZone.run(() => {
          this.toastService.error(err.error?.error || 'Failed to send recovery email');
          this.loading = false;
          this.cdr.detectChanges();
        });
      }
    });
  }
}
